import {useMemo, useState} from "react";
import {MeterFlowVolumeEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {useDebouncedValue} from "@mantine/hooks";

export type UseMeterFlowVolumeDataTableFilterProps = Omit<UseDataTableFilterProps<MeterFlowVolumeEntity>, 'filterConfig'>

export function useMeterFlowVolumeDataTableFilter(props: UseMeterFlowVolumeDataTableFilterProps): UseDataTableFilterResult<MeterFlowVolumeEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [meterQuery, setMeterQuery] = useState<string | undefined>(undefined);
  const [meterDebouncedQuery] = useDebouncedValue(meterQuery, 200);

  const [freightTypeQuery, setFreightTypeQuery] = useState<string | undefined>(undefined);
  const [freightTypeDebouncedQuery] = useDebouncedValue(freightTypeQuery, 200);

  const filterConfig: DataTableFilterConfig<MeterFlowVolumeEntity> = useMemo(() => {
    return {
      "meter": {
        setQuery: setMeterQuery,
        query: meterQuery,
        debouncedQuery: meterDebouncedQuery,
        filter: (record, query) => !record.meterName || !record.meterName.toLowerCase().includes(query.toLowerCase())
      },
      "freightType": {
        setQuery: setFreightTypeQuery,
        query: freightTypeQuery,
        debouncedQuery: freightTypeDebouncedQuery,
        filter: (record, query) => !record.freightTypeName || !record.freightTypeName.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    meterQuery,
    meterDebouncedQuery,
    freightTypeQuery,
    freightTypeDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
